/*
 * qi-collection-filters.js -- icon-rich filter bar for tag collection pages
 * ------------------------------------------------------------------------
 * DATA
 *   /collections/all/<tag>?view=qi-filters (templates/collection.qi-filters.liquid)
 *   returns one small record per product in the WHOLE tag, so every count here
 *   describes the full category, not the 20 cards on screen.
 *
 * WHICH FILTERS APPEAR -- decided per category by assets/qi-facets.js
 *   Style        the category's own sub-tags (Coffee Mugs, Travel Mugs...)
 *                used by 2+ products; feature, size and material tags excluded
 *   Features     tags: 24 Hour Rush, Made in USA, Eco-Friendly, BPA Free, sale;
 *                "New" = published in the last 90 days; "In stock" = available
 *   Attributes   per category: drinkware capacity & material; apparel garment,
 *                fit, fabric & fabric weight; bag type & material; pen type,
 *                mechanism & barrel. A mixed tag also gets "Product type".
 *   Price        two-handle slider on a log scale over what this tag holds
 *   Min order    thresholds that actually split this tag's minimums
 *   A group with nothing to choose between is not shown.
 *
 * CARDS
 *   The first time a filter is applied, any cards not already on the page are
 *   loaded once from ?view=qi-cards (templates/collection.qi-cards.liquid: the
 *   same card snippet, for ANY collection -- ?page=all only expands tag pages)
 *   and the pagination is hidden. Clearing every filter puts the original page
 *   back exactly as it was.
 *
 * THUMBNAILS
 *   Style tiles, product types and "kind of thing" options (garment, material,
 *   bag type...) show a photo of the FIRST product in the collection that has
 *   them, instead of a drawn icon. Measures (capacity, fabric weight, fit) keep
 *   the drawn icon, which says more than a photo would.
 *
 * COUNTS are faceted: each option's number is what you would get by adding it
 * to everything else already selected.
 */
(function () {
  'use strict';

  var root = document.getElementById('qcf');
  if (!root) return;
  var F = window.QIFacets;
  if (!F || !window.fetch || !window.DOMParser || !window.Promise) { root.parentNode.removeChild(root); return; }

  var NOUN = (root.getAttribute('data-noun') || 'products');
  var noun = NOUN.toLowerCase();
  var CURRENT = (root.getAttribute('data-current') || '').toLowerCase().split('|');

  /* ------------------------------------------------------------------ icons */
  var ICONS = {
    bolt: '<path d="M13 2 4.5 13.5H11L10 22l8.5-11.5H12z"/>',
    flag: '<path d="M5 21V4"/><path d="M5 4h13l-2.5 4 2.5 4H5"/>',
    shield: '<path d="M12 3 5 6v6c0 4.4 3 7.6 7 9 4-1.4 7-4.6 7-9V6z"/><path d="m9 12 2 2 4-4"/>',
    tag: '<path d="M3 12.2V4a1 1 0 0 1 1-1h8.2a1 1 0 0 1 .7.3l8.2 8.2a1 1 0 0 1 0 1.4l-8.2 8.2a1 1 0 0 1-1.4 0L3.3 12.9a1 1 0 0 1-.3-.7z"/><circle cx="7.5" cy="7.5" r="1.4"/>',
    sparkle: '<path d="M12 3c.6 4.6 2.4 6.4 7 7-4.6.6-6.4 2.4-7 7-.6-4.6-2.4-6.4-7-7 4.6-.6 6.4-2.4 7-7z"/><path d="M19 16.5c.2 1.4.8 2 2.2 2.2-1.4.2-2 .8-2.2 2.2-.2-1.4-.8-2-2.2-2.2 1.4-.2 2-.8 2.2-2.2z"/>',
    check: '<circle cx="12" cy="12" r="9"/><path d="m8 12.3 2.8 2.7L16.2 9"/>',
    box: '<path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z"/><path d="m3 7.5 9 4.5 9-4.5M12 12v9"/>',
    dollar: '<circle cx="12" cy="12" r="9"/><path d="M15 9.2a3 3 0 0 0-3-1.7c-1.7 0-3 .9-3 2.2 0 3 6 1.6 6 4.6 0 1.3-1.3 2.2-3 2.2a3 3 0 0 1-3-1.7M12 6v1.5M12 16.5V18"/>',
    sliders: '<path d="M4 6h9M17 6h3M4 12h3M11 12h9M4 18h11M19 18h1"/><circle cx="15" cy="6" r="2"/><circle cx="9" cy="12" r="2"/><circle cx="17" cy="18" r="2"/>',
    chev: '<path d="m6 9 6 6 6-6"/>',
    x: '<path d="M6 6l12 12M18 6 6 18"/>'
  };
  for (var k in F.ICONS) if (!ICONS[k]) ICONS[k] = F.ICONS[k];
  function icon(n, cls) { return '<svg viewBox="0 0 24 24" aria-hidden="true"' + (cls ? ' class="' + cls + '"' : '') + '>' + (ICONS[n] || ICONS.grid) + '</svg>'; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function handleize(s) { return String(s).toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function money(v) { return '$' + (v >= 100 ? Math.round(v) : v.toFixed(2)); }
  function styleIcon(tag) {
    var t = tag.toLowerCase();
    if (/straw/.test(t)) return 'straw';
    if (/beer|stein|tankard|pint/.test(t)) return 'beer';
    if (/travel/.test(t)) return 'travel';
    if (/tumbler/.test(t)) return 'tumbler';
    if (/mason|jar/.test(t)) return 'jar';
    if (/wine|glass|goblet/.test(t)) return 'glass';
    if (/camp|enamel/.test(t)) return 'campfire';
    if (/bottle|flask/.test(t)) return 'bottle';
    if (/cup/.test(t)) return 'cup';
    if (/mug/.test(t)) return 'mug';
    if (/cap|hat|beanie|visor/.test(t)) return 'cap';
    if (/polo/.test(t)) return 'polo';
    if (/hood|sweat/.test(t)) return 'hoodie';
    if (/jacket|vest|outerwear/.test(t)) return 'jacket';
    if (/shirt|tee|apparel/.test(t)) return 'shirt';
    if (/backpack/.test(t)) return 'backpack';
    if (/drawstring|cinch/.test(t)) return 'drawstring';
    if (/duffel|gym/.test(t)) return 'duffel';
    if (/cooler|lunch|insulated/.test(t)) return 'cooler';
    if (/laptop|brief/.test(t)) return 'laptop';
    if (/tote|bag|shopper|grocery/.test(t)) return 'tote';
    if (/stylus/.test(t)) return 'stylus';
    if (/highlight/.test(t)) return 'highlighter';
    if (/pencil/.test(t)) return 'pencil';
    if (/marker/.test(t)) return 'marker';
    if (/pen/.test(t)) return 'pen';
    return 'grid';
  }

  /* ------------------------------------------------------- facet definitions */
  var FLAG_DEFS = [
    { v: 'rush', label: '24-Hour Rush', icon: 'bolt', re: /24\s*hour\s*rush/ },
    { v: 'usa', label: 'Made in USA', icon: 'flag', re: /made[\s-]in[\s-]usa/ },
    { v: 'eco', label: 'Eco-Friendly', icon: 'leaf', re: /eco[\s-]?friendly/ },
    { v: 'bpa', label: 'BPA Free', icon: 'shield', re: /bpa[\s-]?free/ },
    { v: 'sale', label: 'On Sale', icon: 'tag', re: /^(on[\s-])?sale$/ },
    { v: 'new', label: 'New', icon: 'sparkle' },
    { v: 'stock', label: 'In stock', icon: 'check' }
  ];
  var FLAG_TAG = /24\s*hour\s*rush|made[\s-]in[\s-]usa|eco[\s-]?friendly|bpa[\s-]?free|^(on[\s-])?sale$|checkout-ready|^new$/;
  var SIZE_TAG = /\b\d+(\.\d+)?\s*(fl\.?\s*)?oz\b/;
  // material-named tags ("Ceramic Mugs", "Cotton Totes"), brand tags and
  // fit tags ("Youth Apparel") belong to their own filters, not the style tiles
  var MAT_WORD = /ceramic|stoneware|porcelain|ironstone|glass|steel|stainless|plastic|acrylic|tritan|enamel|cotton|canvas|jute|non-?woven|nonwoven|polyester|nylon|wood|bamboo|metal|brass|alumin/;

  var items = [], STYLES = [], FLAGS = [], KINDS = [], GROUPS = [], MINS = [], PRICE = null, BANDS = [];
  var S = fresh();
  var colorOrder = [];   // colours in the order they were ticked; the last one leads the card images
  function fresh() { return { style: {}, flag: {}, kind: {}, attr: {}, min: 0, price: {} }; }   // price: ticked bands

  var feedItems = [];
  function model(d) {
    feedItems = d.items;
    items = d.items.map(function (it, i) {
      var tl = it.g.map(function (t) { return t.toLowerCase(); });
      var price = typeof it.p === 'number' ? it.p : parseFloat(it.p);
      var rec = F.derive({ title: it.t, type: it.y, tags: it.g, imgs: it.f });
      var flags = {};
      FLAG_DEFS.forEach(function (f) {
        // On Sale follows the card badge ("s" from the feed: sale tag or on-sale collection)
        flags[f.v] = f.v === 'new' ? !!it.n : f.v === 'stock' ? !!it.a
          : f.v === 'sale' && typeof it.s === 'boolean' ? it.s
          : tl.some(function (t) { return f.re.test(t); });
      });
      return {
        h: it.h, idx: i, tl: tl, flags: flags, kind: rec.kind, attr: rec.attr, img: it.i || null,
        price: isFinite(price) ? price : null,
        min: it.m > 0 ? it.m : 0
      };
    });
    var total = items.length;

    // style: the category's own sub-tags
    var freq = {};
    items.forEach(function (it) { it.tl.forEach(function (t) { freq[t] = (freq[t] || 0) + 1; }); });
    var names = {};
    d.items.forEach(function (it) { it.g.forEach(function (t) { names[t.toLowerCase()] = t; }); });
    STYLES = Object.keys(freq).filter(function (t) {
      return freq[t] >= 2 && freq[t] < total && CURRENT.indexOf(t) === -1 &&
        !FLAG_TAG.test(t) && !SIZE_TAG.test(t) && !MAT_WORD.test(t) &&
        !F.isBrand(t) && !/\b(youth|kids?|ladies|women'?s?|toddler)\b/.test(t);
    }).sort(function (a, b) { return freq[b] - freq[a]; }).slice(0, 10);
    var usedStyle = {};
    STYLES = STYLES.map(function (t) {
      return { v: t, label: names[t], icon: styleIcon(t), img: firstImg(function (it) { return it.tl.indexOf(t) > -1; }, usedStyle) };
    });
    if (STYLES.length < 2) STYLES = [];

    FLAGS = FLAG_DEFS.filter(function (f) {
      var n = items.filter(function (it) { return it.flags[f.v]; }).length;
      return n > 0 && n < total;   // a toggle that changes nothing is noise
    });
    MINS = F.minSteps(items.map(function (it) { return it.min; }));
    // Price Per Unit: the same quartile bands as the search page ("Under $7", "$7 - $10" ...)
    BANDS = F.priceBands(items.map(function (it) { return it.price; }));
    PRICE = BANDS.length ? true : null;
    replan();
  }
  // the attribute groups depend on which product type is picked, if any
  function replan() {
    var p = F.plan(items, S.kind);
    KINDS = p.kinds;
    GROUPS = p.groups;
    // drop selections in groups that are no longer offered
    var keep = {};
    GROUPS.forEach(function (gr) { keep[gr.g] = 1; });
    for (var g in S.attr) if (!keep[g]) delete S.attr[g];
  }
  function groupOf(g) { for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].g === g) return GROUPS[i]; return null; }
  // photo of the first product (collection order) that fits, for tile / option icons.
  // "used" keeps one row's photos distinct: a product tagged Tumblers + Travel Mugs +
  // Cups would otherwise put the same photo on all three tiles.
  function firstImg(test, used) {
    var fallback = null;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.img || !test(it)) continue;
      if (!used || !used[it.img]) { if (used) used[it.img] = 1; return it.img; }
      if (!fallback) fallback = it.img;
    }
    return fallback;
  }
  function thumb(src, cls) {
    return '<span class="ic ph' + (cls ? ' ' + cls : '') + '"><img src="' + esc(src) + '" alt="" loading="lazy" decoding="async" width="80" height="80"></span>';
  }

  /* --------------------------------------------------------------- matching */
  function anyOn(o) { for (var k in o) if (o[k]) return true; return false; }
  function active() {
    if (anyOn(S.style) || anyOn(S.flag) || anyOn(S.kind) || S.min || anyOn(S.price)) return true;
    for (var g in S.attr) if (anyOn(S.attr[g])) return true;
    return false;
  }
  function hit(list, on) { if (!list) return false; for (var i = 0; i < list.length; i++) if (on[list[i]]) return true; return false; }

  // skip: a group left out for its own facet counts ('style', 'kind', 'min',
  // 'price', 'attr:<g>', or one flag 'flag:<v>')
  function match(it, skip) {
    if (skip !== 'style' && anyOn(S.style) && !it.tl.some(function (t) { return S.style[t]; })) return false;
    for (var f in S.flag) if (S.flag[f] && skip !== 'flag:' + f && !it.flags[f]) return false;
    if (skip !== 'kind' && anyOn(S.kind) && !S.kind[it.kind]) return false;
    for (var g in S.attr) if (skip !== 'attr:' + g && anyOn(S.attr[g]) && !hit(it.attr[g], S.attr[g])) return false;
    if (skip !== 'min' && S.min && !(it.min > 0 && it.min <= S.min)) return false;
    if (skip !== 'price' && anyOn(S.price) && !BANDS.some(function (b) { return S.price[b.v] && inBand(it, b); })) return false;
    return true;
  }
  function inBand(it, b) { return it.price !== null && it.price >= b.lo && it.price < b.hi; }
  function count(skip, test) { var n = 0; for (var i = 0; i < items.length; i++) if (match(items[i], skip) && test(items[i])) n++; return n; }
  function matched() { return items.filter(function (it) { return match(it); }); }

  /* ------------------------------------------------------------- rendering */
  var openPop = null, sheetOpen = false;

  function flagBtn(f) {
    var on = !!S.flag[f.v], n = count('flag:' + f.v, function (it) { return it.flags[f.v]; });
    return '<button type="button" class="qcf-flag" data-g="flag" data-v="' + f.v + '" aria-pressed="' + on + '"' +
      (n === 0 && !on ? ' disabled' : '') + '>' + icon(f.icon) + esc(f.label) + ' <span class="ct">' + n + '</span></button>';
  }
  /* One filter row, the same as the search sidebar: a checkbox (round for the
     single-choice minimum), the label and its count. A button, so the one click
     handler serves the panel, the phone sheet and the popovers. */
  function chk(g, v, label, n, on, radio) {
    if (!n && !on) return '';
    return '<button type="button" class="qcf-chk' + (radio ? ' radio' : '') + '" data-g="' + esc(g) + '" data-v="' + esc(v) +
      '" aria-pressed="' + !!on + '"><i aria-hidden="true"></i><span class="t">' + esc(label) + '</span><span class="n">' + n + '</span></button>';
  }
  function chkList(rows) { return '<div class="qcf-chks">' + rows.join('') + '</div>'; }
  function groupBody(g) {
    if (g === 'style') {
      return chkList(STYLES.map(function (s) {
        return chk('style', s.v, s.label, count('style', function (it) { return it.tl.indexOf(s.v) > -1; }), S.style[s.v]);
      }));
    }
    if (g === 'kind') {
      return chkList(KINDS.map(function (kd) {
        return chk('kind', kd, F.KINDS[kd].label, count('kind', function (it) { return it.kind === kd; }), S.kind[kd]);
      }));
    }
    if (g === 'min') {
      return chkList(MINS.map(function (q) {
        return chk('min', q, q + ' or fewer', count('min', function (it) { return it.min > 0 && it.min <= q; }), S.min === q, true);
      }));
    }
    if (g === 'price') {
      return chkList(BANDS.map(function (b) {
        return chk('price', b.v, b.label, count('price', function (it) { return inBand(it, b); }), S.price[b.v]);
      }));
    }
    if (g === 'flag') {
      return chkList(FLAGS.map(function (f) {
        return chk('flag', f.v, f.label, count('flag:' + f.v, function (it) { return it.flags[f.v]; }), S.flag[f.v]);
      }));
    }
    var gr = groupOf(g);
    if (!gr) return '';
    var on = S.attr[g] || {};
    if (g === 'color') {   // "Color Family": a grid of round swatches, name + count on hover
      return '<div class="qcf-swatches">' + gr.opts.map(function (o) {
        var n = count('attr:color', function (it) { return it.attr.color && it.attr.color.indexOf(o.v) > -1; });
        if (!n && !on[o.v]) return '';
        var tip = o.label + ' (' + n + ')';
        return '<button type="button" class="qcf-swb" data-g="color" data-v="' + esc(o.v) + '" aria-pressed="' + !!on[o.v] + '" title="' + esc(tip) +
          '" aria-label="' + esc(tip) + '"><span style="background:' + esc(o.swatch || '#ccc') + '"></span></button>';
      }).join('') + '</div>';
    }
    return chkList(gr.opts.map(function (o) {
      return chk(g, o.v, o.label, count('attr:' + g, function (it) { return it.attr[g] && it.attr[g].indexOf(o.v) > -1; }), on[o.v]);
    }));
  }

  function pill(g, ic, label, activeN) {
    return '<button type="button" class="qcf-pill' + (activeN ? ' on' : '') + '" data-pop="' + esc(g) + '" aria-haspopup="true" aria-expanded="' + (openPop === g) + '">' +
      icon(ic) + esc(label) + (activeN ? ' <span class="dot">' + activeN + '</span>' : '') + icon('chev', 'chev') + '</button>';
  }
  function nOn(o) { var n = 0; for (var k in o) if (o[k]) n++; return n; }
  function title(g) {
    if (g === 'kind') return 'Product Type';
    if (g === 'price') return 'Price Per Unit';
    if (g === 'min') return 'Minimum Order';
    var gr = groupOf(g); return gr ? gr.title : '';
  }

  function chipsHtml() {
    var c = [];
    function chip(g, v, label) { c.push('<button type="button" class="qcf-chip" data-chip="' + esc(g) + '" data-v="' + esc(v) + '">' + esc(label) + icon('x') + '</button>'); }
    STYLES.forEach(function (s) { if (S.style[s.v]) chip('style', s.v, s.label); });
    KINDS.forEach(function (kd) { if (S.kind[kd]) chip('kind', kd, F.KINDS[kd].label); });
    FLAGS.forEach(function (f) { if (S.flag[f.v]) chip('flag', f.v, f.label); });
    GROUPS.forEach(function (gr) {
      var on = S.attr[gr.g] || {};
      gr.opts.forEach(function (o) { if (on[o.v]) chip(gr.g, o.v, o.label); });
    });
    if (S.min) chip('min', S.min, 'Min. order ≤ ' + S.min);
    BANDS.forEach(function (b) { if (S.price[b.v]) chip('price', b.v, b.label); });
    if (c.length > 1) c.push('<button type="button" class="qcf-link qcf-clear" data-clear>Clear all</button>');
    return c.join('');
  }

  function countHtml() {
    var n = matched().length;
    return active() ? 'Showing <b>' + n + '</b> of ' + items.length + ' ' + esc(noun) : '<b>' + items.length + '</b> ' + esc(noun);
  }

  function renderMain() {
    // no "Shop ... by style" heading or style tiles: Style is a section of the left
    // panel (desktop) and of the phone sheet; the count sits in the panel header
    var h = '';
    var total = nOn(S.style) + nOn(S.flag) + nOn(S.kind) + (S.min ? 1 : 0) + nOn(S.price);
    for (var g in S.attr) total += nOn(S.attr[g]);
    // Color and Price lead the bar (the two filters shoppers reach for first),
    // then the feature flags, then the category-specific dropdowns
    var lead = '', pills = '';
    GROUPS.forEach(function (gr) { if (gr.g === 'color') lead += pill(gr.g, gr.icon, gr.title, nOn(S.attr[gr.g] || {})); });
    if (PRICE) lead += pill('price', 'dollar', 'Price', nOn(S.price));
    if (KINDS.length) pills += pill('kind', 'grid', 'Product Type', nOn(S.kind));
    GROUPS.forEach(function (gr) { if (gr.g !== 'color') pills += pill(gr.g, gr.icon, gr.title, nOn(S.attr[gr.g] || {})); });
    if (MINS.length) pills += pill('min', 'box', 'Min. order', S.min ? 1 : 0);
    var sep = '<span class="qcf-sep" aria-hidden="true"></span>', flags = FLAGS.map(flagBtn).join('');
    h += '<div class="qcf-bar" role="toolbar" aria-label="Filters">' +
      '<button type="button" class="qcf-mfilters" data-sheet>' + icon('sliders') + 'Filters' + (total ? ' <span class="dot">' + total + '</span>' : '') + '</button>' +
      lead + (lead && flags ? sep : '') + flags + ((lead || flags) && pills ? sep : '') + pills +
      '</div><div class="qcf-active">' + chipsHtml() + '</div>';

    var focusKey = document.activeElement && root.contains(document.activeElement) ? keyOf(document.activeElement) : null;
    var pop = root.querySelector('.qcf-pop');
    root.innerHTML = h;
    if (pop) root.appendChild(pop);
    restoreFocus(root, focusKey);
  }
  function keyOf(el) {
    if (el.getAttribute('data-end')) return 'end:' + el.getAttribute('data-end');
    return el.getAttribute('data-pop') ? 'pop:' + el.getAttribute('data-pop')
      : el.getAttribute('data-g') ? el.getAttribute('data-g') + ':' + el.getAttribute('data-v') : null;
  }
  function restoreFocus(scope, key) {
    if (!key) return;
    var p = key.split(':'), el = p[0] === 'end' ? scope.querySelector('input[data-end="' + p[1] + '"]')
      : p[0] === 'pop' ? scope.querySelector('[data-pop="' + p[1] + '"]')
      : scope.querySelector('[data-g="' + p[0] + '"][data-v="' + p.slice(1).join(':') + '"]');
    if (el && !el.disabled) el.focus();
  }

  function renderPop() {
    var old = root.querySelector('.qcf-pop');
    if (openPop && openPop !== 'price' && openPop !== 'min' && openPop !== 'kind' && !groupOf(openPop)) openPop = null;
    if (!openPop) { if (old) old.parentNode.removeChild(old); return; }
    var focusKey = old && old.contains(document.activeElement) ? keyOf(document.activeElement) : null;
    var pop = document.createElement('div');
    pop.className = 'qcf-pop';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-label', title(openPop));
    pop.innerHTML = '<h3>' + esc(title(openPop)) + '</h3>' + groupBody(openPop) +
      '<div class="qcf-done"><button type="button" class="qcf-link" data-reset="' + esc(openPop) + '">Clear</button>' +
      '<button type="button" class="qcf-go" data-close>Show ' + matched().length + ' ' + esc(noun) + '</button></div>';
    if (old) old.parentNode.removeChild(old);
    root.appendChild(pop);
    var trig = root.querySelector('[data-pop="' + openPop + '"]');
    if (trig) {
      var rr = root.getBoundingClientRect(), tr = trig.getBoundingClientRect();
      var left = Math.max(0, Math.min(tr.left - rr.left, rr.width - pop.offsetWidth));
      pop.style.left = left + 'px';
      pop.style.top = (tr.bottom - rr.top + 8) + 'px';
    }
    restoreFocus(pop, focusKey);
  }

  var sheet = null, scrim = null;
  function renderSheet() {
    if (!sheetOpen) {
      if (sheet) { sheet.parentNode.removeChild(sheet); scrim.parentNode.removeChild(scrim); sheet = scrim = null; document.documentElement.style.overflow = ''; }
      return;
    }
    if (!sheet) {
      scrim = document.createElement('div'); scrim.className = 'qcf-scrim qcf';
      sheet = document.createElement('div'); sheet.className = 'qcf qcf-sheet'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-label', 'Filters');
      document.body.appendChild(scrim); document.body.appendChild(sheet);
      document.documentElement.style.overflow = 'hidden';
      sheet.addEventListener('click', onClick);
      scrim.addEventListener('click', function () { sheetOpen = false; renderSheet(); });
    }
    var body = sheet.querySelector('.qcf-sheet-b'), scroll = body ? body.scrollTop : 0;
    var focusKey = sheet.contains(document.activeElement) ? keyOf(document.activeElement) : null;
    var secs = '';
    function sec(t, g) { secs += '<div class="qcf-sec"><h3>' + esc(t) + '</h3>' + groupBody(g) + '</div>'; }
    // same order as the desktop panel (see renderSide)
    if (FLAGS.length) sec('Special Selections', 'flag');
    if (PRICE) sec('Price Per Unit', 'price');
    GROUPS.forEach(function (gr) { if (gr.g === 'garment') sec(gr.title, gr.g); });
    GROUPS.forEach(function (gr) { if (gr.g === 'color') sec('Color Family', gr.g); });
    if (STYLES.length) sec('Style', 'style');
    if (KINDS.length) sec('Product Type', 'kind');
    GROUPS.forEach(function (gr) { if (gr.g !== 'color' && gr.g !== 'garment') sec(gr.title, gr.g); });
    if (MINS.length) sec('Minimum Order', 'min');
    sheet.innerHTML = '<div class="qcf-sheet-h"><b>Filter ' + esc(noun) + '</b><button type="button" class="qcf-x" data-sheet-close aria-label="Close">' + icon('x') + '</button></div>' +
      '<div class="qcf-sheet-b">' + secs + '</div>' +
      '<div class="qcf-sheet-f"><button type="button" class="qcf-link" data-clear>Clear all</button>' +
      '<button type="button" class="qcf-go" data-sheet-close>Show ' + matched().length + ' ' + esc(noun) + '</button></div>';
    sheet.querySelector('.qcf-sheet-b').scrollTop = scroll;
    restoreFocus(sheet, focusKey);
  }

  /* Left panel (desktop, like the search page): the grid moves into a two-column
     layout with the filters beside it. The pill bar and its popovers are for
     phones only (CSS), where the "Filters" button opens the sheet. */
  var side = null, shut = {};   // shut[g]: that section is collapsed (minus / plus on its heading)
  function buildSide() {
    if (side || !grid) return;
    var layout = document.createElement('div'); layout.className = 'qcf-layout';
    side = document.createElement('aside'); side.className = 'qcf qcf-side'; side.setAttribute('aria-label', 'Filter ' + noun);
    var main = document.createElement('div'); main.className = 'qcf-main';
    grid.parentNode.insertBefore(layout, grid);
    layout.appendChild(side); layout.appendChild(main); main.appendChild(grid);
    side.addEventListener('click', function (e) {
      var tog = e.target.closest && e.target.closest('[data-sectog]');
      if (tog) {
        var tg = tog.getAttribute('data-sectog');
        shut[tg] = !shut[tg]; renderSide();
        var again = side.querySelector('[data-sectog="' + tg + '"]'); if (again) again.focus();
        return;
      }
      onClick(e);
    });
  }
  function renderSide() {
    buildSide();
    if (!side) return;
    var focusKey = side.contains(document.activeElement) ? keyOf(document.activeElement) : null;
    var secs = '';
    // every section collapses from its heading; the dot counts its active picks
    function picks(g) {
      return g === 'style' || g === 'flag' || g === 'kind' ? nOn(S[g]) : g === 'min' ? (S.min ? 1 : 0)
        : g === 'price' ? nOn(S.price) : nOn(S.attr[g] || {});
    }
    function sec(t, g) {
      var b = groupBody(g);
      if (!b) return;
      var open = !shut[g], n = picks(g);
      secs += '<div class="qcf-sec' + (open ? '' : ' shut') + '" data-sec="' + g + '">' +
        '<h3><button type="button" class="qcf-sectog" data-sectog="' + g + '" aria-expanded="' + open + '">' + esc(t) +
        (n ? ' <span class="dot">' + n + '</span>' : '') + '<i aria-hidden="true"></i></button></h3>' +
        (open ? b : '') + '</div>';
    }
    // order agreed with the client: Special Selections, Price Per Unit, Garment Type
    // (apparel), Color Family, then the rest
    if (FLAGS.length) sec('Special Selections', 'flag');
    if (PRICE) sec('Price Per Unit', 'price');
    GROUPS.forEach(function (gr) { if (gr.g === 'garment') sec(gr.title, gr.g); });
    GROUPS.forEach(function (gr) { if (gr.g === 'color') sec('Color Family', 'color'); });
    if (STYLES.length) sec('Style', 'style');
    if (KINDS.length) sec('Product Type', 'kind');
    GROUPS.forEach(function (gr) { if (gr.g !== 'color' && gr.g !== 'garment') sec(gr.title, gr.g); });
    if (MINS.length) sec('Minimum Order', 'min');
    var total = nOn(S.style) + nOn(S.flag) + nOn(S.kind) + (S.min ? 1 : 0) + nOn(S.price);
    for (var g in S.attr) total += nOn(S.attr[g]);
    side.innerHTML = '<div class="qcf-side-h"><b>Filters</b>' + (total ? '<button type="button" class="qcf-link" data-clear>Clear all</button>' : '') +
      '<span class="qcf-count" aria-live="polite">' + countHtml() + '</span></div>' + secs;
    restoreFocus(side, focusKey);
    if (F.fitPanels) F.fitPanels();   // fit the panel to the visible space (qi-facets.js)
  }

  function update() { renderMain(); renderPop(); renderSheet(); renderSide(); applyGridSoon(); syncUrl(); }

  /* ------------------------------------------------------------ interaction */
  function toggle(g, v) {
    if (g === 'min') { v = +v; S.min = S.min === v ? 0 : v; return; }
    if (g === 'style' || g === 'flag' || g === 'price') { S[g][v] = !S[g][v]; return; }
    if (g === 'kind') { S.kind[v] = !S.kind[v]; replan(); return; }
    S.attr[g] = S.attr[g] || {};
    S.attr[g][v] = !S.attr[g][v];
    if (g === 'color') {                                     // newest pick moves to the end
      colorOrder = colorOrder.filter(function (c) { return c !== v; });
      if (S.attr[g][v]) colorOrder.push(v);
    }
  }
  function clearGroup(g) {
    if (g === 'min') S.min = 0;
    else if (g === 'price') S.price = {};
    else if (g === 'style' || g === 'flag') S[g] = {};
    else if (g === 'kind') { S.kind = {}; replan(); }
    else delete S.attr[g];
  }
  function onClick(e) {
    var t = e.target.closest ? e.target.closest('button,[data-sheet-close]') : null;
    if (!t) return;
    if (t.hasAttribute('data-sheet')) { sheetOpen = true; openPop = null; renderPop(); renderSheet(); return; }
    if (t.hasAttribute('data-sheet-close')) { sheetOpen = false; renderSheet(); return; }
    if (t.hasAttribute('data-pop')) { var g = t.getAttribute('data-pop'); openPop = openPop === g ? null : g; renderMain(); renderPop(); return; }
    if (t.hasAttribute('data-close')) { openPop = null; renderMain(); renderPop(); return; }
    if (t.hasAttribute('data-clear')) { S = fresh(); replan(); update(); return; }
    if (t.hasAttribute('data-reset')) { clearGroup(t.getAttribute('data-reset')); update(); return; }
    if (t.hasAttribute('data-chip')) {
      var cg = t.getAttribute('data-chip'), cv = t.getAttribute('data-v');
      if (cg === 'min') clearGroup(cg);
      else if (cg === 'style' || cg === 'flag' || cg === 'price') S[cg][cv] = false;
      else if (cg === 'kind') { S.kind[cv] = false; replan(); }
      else if (S.attr[cg]) S.attr[cg][cv] = false;
      update(); return;
    }
    if (t.hasAttribute('data-g') && !t.disabled) { toggle(t.getAttribute('data-g'), t.getAttribute('data-v')); update(); }
  }
  root.addEventListener('click', onClick);
  document.addEventListener('click', function (e) {
    // a click inside the bar re-renders it, so by the time the event reaches the
    // document its target may already be detached -- that is not "outside"
    if (!e.target.isConnected) return;
    if (openPop && !root.contains(e.target)) { openPop = null; renderMain(); renderPop(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (sheetOpen) { sheetOpen = false; renderSheet(); }
    else if (openPop) { var g = openPop; openPop = null; renderMain(); renderPop(); var b = root.querySelector('[data-pop="' + g + '"]'); if (b) b.focus(); }
  });

  /* -------------------------------------------------------------- the grid */
  var ITEM = '.grid-item[data-minqty][data-handle]';
  var grid = (function () {
    var gs = document.querySelectorAll('.grid-uniform');
    for (var i = 0; i < gs.length; i++) if (gs[i].querySelector(ITEM)) return gs[i];
    return null;
  })();
  var PAGER = '.pagination-border-top, .pagination';
  var original = null, cards = null, order = null, loadP = null;

  // the width classes this template gives its cards (quarters, fifths...)
  var WIDTH = /^(large|medium|small|medium-down|large-up)--/;
  function widthOf(n) { return String(n.className).split(/\s+/).filter(function (c) { return WIDTH.test(c); }); }
  function loadCards() {
    if (loadP) return loadP;
    var onPage = [].slice.call(grid.querySelectorAll(ITEM));
    var model = onPage.length ? widthOf(onPage[0]) : [];
    function take(nodes, imp) {
      cards = {}; order = [];
      nodes.forEach(function (n) {
        var h = n.getAttribute('data-handle');
        if (!h || cards[h]) return;
        if (imp) {
          n = document.importNode(n, true);
          if (model.length) {
            widthOf(n).forEach(function (c) { n.classList.remove(c); });
            model.forEach(function (c) { n.classList.add(c); });
          }
        }
        cards[h] = n; order.push(h);
      });
    }
    // every product already on screen (one page, or top-sellers' single block)?
    var have = {};
    onPage.forEach(function (n) { have[n.getAttribute('data-handle')] = 1; });
    if (items.every(function (it) { return have[it.h]; })) { take(onPage, false); loadP = Promise.resolve(); return loadP; }
    var sort = /[?&]sort_by=([^&]*)/.exec(location.search);
    grid.classList.add('qcf-loading');
    loadP = fetch(location.pathname + '?view=qi-cards' + (sort ? '&sort_by=' + sort[1] : ''), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        take([].slice.call(doc.querySelectorAll('.grid-uniform ' + ITEM)), true);
      })
      .catch(function () { take([].slice.call(grid.querySelectorAll(ITEM)), false); cards.partial = true; })
      .then(function () { grid.classList.remove('qcf-loading'); });
    return loadP;
  }
  // honour the theme's client-side Min/Max Order Qty sort (qi-minqty-sort.js)
  function qiSort(list) {
    var m = /[?&]qi_sort=(qi-minqty-(?:ascending|descending))/.exec(location.search);
    if (!m) return list;
    var desc = /descending/.test(m[1]);
    return list.slice().sort(function (a, b) {
      var x = +a.getAttribute('data-minqty'), y = +b.getAttribute('data-minqty');
      if (x < 0 && y < 0) return 0; if (x < 0) return 1; if (y < 0) return -1;
      return desc ? y - x : x - y;
    });
  }
  function setPagers(show) {
    [].forEach.call(document.querySelectorAll(PAGER), function (p) { p.style.display = show ? '' : 'none'; });
  }
  // cards show the colour picked last (QIFacets.showColor); feed filenames by handle
  var IMGS = null;
  function paintColors(nodes) {
    if (!F.showColor) return;
    if (!IMGS) { IMGS = {}; feedItems.forEach(function (it) { IMGS[it.h] = it.f || ''; }); }
    colorOrder = F.pickOrder(colorOrder, S.attr.color || {});
    var wanted = colorOrder.slice().reverse();
    nodes.forEach(function (n) { F.showColor(n, IMGS[n.getAttribute('data-handle')] || '', wanted); });
  }
  function restore() {
    if (!original) return;
    while (grid.firstChild) grid.removeChild(grid.firstChild);
    original.forEach(function (n) { grid.appendChild(n); });
    original = null;
    setPagers(true);
    paintColors([].slice.call(grid.querySelectorAll(ITEM)));
  }
  function applyGrid() {
    if (!grid) return;
    if (!active()) { restore(); return; }
    loadCards().then(function () {
      if (!active()) { restore(); return; }
      if (!original) original = [].slice.call(grid.childNodes);
      var want = {};
      matched().forEach(function (it) { want[it.h] = 1; });
      var list = qiSort(order.filter(function (h) { return want[h]; }).map(function (h) { return cards[h]; }));
      var frag = document.createDocumentFragment();
      list.forEach(function (n) { frag.appendChild(n); });
      if (!list.length) {
        var e = document.createElement('div');
        e.className = 'qcf-empty';
        e.innerHTML = '<h3>No ' + esc(noun) + ' match all of those</h3><p>Loosen a filter, or tell us what you need and we’ll find it.</p>' +
          '<button type="button" class="qcf-go" data-qcf-clear>Clear filters</button>' +
          '<a class="qcf-ghost" href="/pages/quote-request">Get a free quote</a>';
        e.querySelector('[data-qcf-clear]').addEventListener('click', function () { S = fresh(); replan(); update(); });
        frag.appendChild(e);
      }
      while (grid.firstChild) grid.removeChild(grid.firstChild);
      grid.appendChild(frag);
      setPagers(false);
      paintColors(list);
    });
  }
  var gridT = null;
  function applyGridSoon() { clearTimeout(gridT); gridT = setTimeout(applyGrid, 90); }

  /* --------------------------------------------------------------- the URL */
  // ?qf=style~coffee-mugs.travel-mugs|kind~drink|flag~usa|mat~ceramic|min~50|price~p0.p2
  function syncUrl() {
    var parts = [];
    var st = STYLES.filter(function (s) { return S.style[s.v]; }).map(function (s) { return handleize(s.v); });
    if (st.length) parts.push('style~' + st.join('.'));
    function on(o) { return Object.keys(o).filter(function (k) { return o[k]; }); }
    if (on(S.kind).length) parts.push('kind~' + on(S.kind).join('.'));
    if (on(S.flag).length) parts.push('flag~' + on(S.flag).join('.'));
    for (var g in S.attr) if (on(S.attr[g]).length) parts.push(g + '~' + on(S.attr[g]).join('.'));
    if (S.min) parts.push('min~' + S.min);
    if (on(S.price).length) parts.push('price~' + on(S.price).join('.'));
    var q = location.search.replace(/([?&])qf=[^&]*&?/, '$1').replace(/[?&]$/, '');
    // ?color= is an entry point only; ?qf= holds the state from here on
    q = q.replace(/([?&])color=[^&]*/g, '$1').replace(/&{2,}/g, '&').replace(/\?&/, '?').replace(/[?&]$/, '');
    if (parts.length) q += (q ? '&' : '?') + 'qf=' + encodeURIComponent(parts.join('|'));
    try { history.replaceState(history.state, '', location.pathname + q + location.hash); } catch (e) {}
  }
  function readUrl() {
    var m = /[?&]qf=([^&]*)/.exec(location.search);
    if (!m) return;
    var parts = decodeURIComponent(m[1]).split('|');
    // product type first: it decides which attribute groups exist
    parts.forEach(function (p) {
      var kv = p.split('~');
      if (kv[0] === 'kind') (kv[1] || '').split('.').forEach(function (v) { if (KINDS.indexOf(v) > -1) S.kind[v] = true; });
    });
    replan();
    parts.forEach(function (p) {
      var kv = p.split('~'), g = kv[0], vals = (kv[1] || '').split('.');
      if (g === 'style') STYLES.forEach(function (s) { if (vals.indexOf(handleize(s.v)) > -1) S.style[s.v] = true; });
      else if (g === 'flag') FLAGS.forEach(function (f) { if (vals.indexOf(f.v) > -1) S.flag[f.v] = true; });
      else if (g === 'min') S.min = MINS.indexOf(+kv[1]) > -1 ? +kv[1] : 0;
      else if (g === 'price') BANDS.forEach(function (b) { if (vals.indexOf(b.v) > -1) S.price[b.v] = true; });
      else {
        var gr = groupOf(g);
        if (gr) vals.forEach(function (v) { if (gr.byV[v]) { S.attr[g] = S.attr[g] || {}; S.attr[g][v] = true; } });
      }
    });
  }

  // ?color=yellow on arrival: tick those colours (last one leads the images).
  // syncUrl then writes them into ?qf= and drops ?color=, so unticking sticks.
  function readColorParam() {
    var cg = groupOf('color');
    if (!cg) return;
    F.colorsFromUrl(location.search).forEach(function (v) {
      if (!cg.byV[v]) return;
      S.attr.color = S.attr.color || {};
      S.attr.color[v] = true;
      colorOrder = colorOrder.filter(function (c) { return c !== v; });
      colorOrder.push(v);
    });
    if (/[?&]color=/.test(location.search)) syncUrl();
  }

  /* ------------------------------------------------------------------ boot */
  fetch(location.pathname + '?view=qi-filters', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.text() : null; })
    .then(function (t) {
      var d = null; try { d = JSON.parse(t); } catch (e) {}
      if (!d || !d.items || d.items.length < 2 || !grid) { root.parentNode.removeChild(root); return; }
      model(d);
      if (!STYLES.length && !FLAGS.length && !KINDS.length && !GROUPS.length && !PRICE && !MINS.length) { root.parentNode.removeChild(root); return; }
      readUrl();
      readColorParam();
      renderMain();
      renderSide();
      if (active()) applyGrid();
    })
    .catch(function () { if (root.parentNode) root.parentNode.removeChild(root); });
})();
